// Beginning the platform sign-in (02-DESIGN/03-console/01-the-console.md
// § signing in): the one step the sign-in card's primary takes, lifted out of
// the card so the front page's *Get started* takes exactly the same step
// (03-the-signed-out-site.md § the opening). Nothing is written to the
// browser's storage until the person presses it.

import { useState } from "react";

import { usePage } from "../../platform/session.tsx";
import { begin } from "../../signin/flow.ts";
import { choices, type Choice } from "../../signin/provider.ts";
import { describe } from "../../ui/components.tsx";

export interface PlatformSignIn {
  /** The platform's sign-in, or undefined where it cannot sign anyone in here. */
  readonly choice: Choice | undefined;
  /** Why it cannot, where it cannot. */
  readonly choiceErr: unknown;
  /** A sign-in is on its way to the provider. */
  readonly busy: boolean;
  /** What went wrong beginning it. */
  readonly err: string | undefined;
  readonly setErr: (err: string | undefined) => void;
  /** signIn begins the platform sign-in and leaves for the provider. */
  readonly signIn: () => void;
}

export function usePlatformSignIn(): PlatformSignIn {
  const { origin, platform } = usePage();
  const [err, setErr] = useState<string | undefined>(undefined);
  const [busy, setBusy] = useState(false);

  let choice: Choice | undefined;
  let choiceErr: unknown;
  try {
    choice = choices(origin, platform, null)[0];
  } catch (e) {
    choiceErr = e;
  }

  const signIn = () => {
    if (choice === undefined) {
      return;
    }
    setBusy(true);
    begin(origin, choice, "/").then(
      (to) => {
        window.location.assign(to);
      },
      (e: unknown) => {
        setBusy(false);
        setErr(describe(e));
      },
    );
  };

  return { choice, choiceErr, busy, err, setErr, signIn };
}
